<template>
    <div class="modal fade " id="extraChargeModal">
        <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header bg-soft-info">
                    <h5 class="modal-title">Extra Charges</h5>
                    <button type="button" class="close" data-dismiss="modal"><i  class="ri-close-line"></i></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <div v-if="errorMessage" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li>{{errorMessage}}</li>
                        </ul>
                    </div>
                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>
                    <form>

                        <div class="form-group">
                            <label for="cost_type">Charge name</label>
                            <select name="cars" class="custom-select" v-model="cost_type">
                                <option v-for="(item) in chargeTypes" :value="item">{{item}}</option>
                            </select>

                        </div>
                        <div class="form-group" v-if="cost_type == 'Custom'">
                            <input type="text" class="form-control" placeholder="" v-model="chargeData.cost_type" id="cost_type">
                        </div>
                        <div class="form-group">
                            <label for="quantity">Amount</label>
                            <input type="text" class="form-control" placeholder="" v-model="chargeData.quantity" id="quantity">
                        </div>
                        <div class="form-group">
                            <label for="amount">Cost</label>
                            <input type="text" class="form-control" placeholder="" v-model="chargeData.amount" id="amount">
                        </div>
                    </form>
                    <div class="mt-3 text-right">
                        <button type="button" class="btn btn-danger me-1" data-dismiss="modal">Cancel</button>
                        <template v-if="order">
                            <button type="button" class="btn btn-primary close-modal" v-on:click="save" :class="{'disabled': this.loading}">Save Now</button>
                        </template>
                        <template v-else>
                            <button type="button" class="btn btn-primary close-modal" v-on:click="sendData" :class="{'disabled': this.loading}">Save Now</button>
                        </template>

                    </div>
                </div>

                <!-- Modal footer -->


            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";

export default {
    name: "OrderExtraChargeModal",
    props: ['order', 'sub_total_cost', 'charge', 'bus', 'is_edit'],
    created() {
        if(this.charge) {
            this.chargeData = _.cloneDeep(this.charge);
        }
    },
    beforeMount() {
        if(this.charge) {
            this.chargeData = _.cloneDeep(this.charge);
        }
    },
    mounted() {
        if(this.charge) {
            this.chargeData = _.cloneDeep(this.charge);
        }
        this.bus.$on('setChargeData', (charge) => {
            this.chargeData = _.cloneDeep(charge);
        });
        this.bus.$on('setChargeDataWithIndex', (charge, chargeIndex) => {
            this.chargeData = _.cloneDeep(charge);
            this.chargeIndex = chargeIndex;
        });
        //console.log(this.chargeData)
    },
    data() {
        return {
            submitted: false,
            chargeIndex: null,
            chargeData: {
                id: null,
                order_id: null,
                cost_type: 'Cylinders',
                amount: 0.00,
                quantity: 0,
            },
            chargeTypes:['Cylinders', 'Freight', 'Tooling', 'Custom'],
            cost_type: 'Cylinders'
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        sendData(){
            this.$emit('extraChargeAdded', {chargeData: _.cloneDeep(this.chargeData), chargeIndex: this.chargeIndex});
            setTimeout(() => {
                this.chargeIndex = null;
                this.chargeData = {
                    id: null,
                    order_id: null,
                    cost_type: null,
                    amount: 0.00,
                    quantity: 0,
                };
                $('#extraChargeModal').modal('hide');
            }, 100);

        },
        save() {
            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let apiUrl = window.route('orders.charge.store', {id: this.order.id});

            if(this.chargeData.id) {
                apiUrl = window.route('orders.charge.update', {id: this.order.id, extra_charge_id: this.chargeData.id});
            }
            return axios.post(apiUrl, this.chargeData, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if(data.data) {
                        self.setSuccessMessage(data.message);
                        // this.chargeData = data.data;
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.$emit('extraChargeUpdated', {oldData: this.chargeData, newData: data.data});
                        this.chargeData = {
                            id: null,
                            order_id: null,
                            cost_type: null,
                            amount: 0.00,
                            quantity: 0,
                        };
                        $('#extraChargeModal').modal('hide');
                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    },
    watch: {
        cost_type: {
            handler: function (valueAfter, valueBefore) {
                if(valueAfter != 'Custom') {
                    this.chargeData.cost_type = valueAfter;
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
